













import { Component, Vue, Prop, Emit } from 'vue-property-decorator'
import { QueryUserWealthRecordList,ExportUserWealthRecord } from '@/api'
import { VImageUpload } from '@/components/upload'
import constant from '@/utils/constant'
import { VQuery, VTable, QueryModel, TableHander, TableOperation } from '@/components/table'
import {WealthTypeFormat,WealthWayTypeFormat,WealthStatusFormat} from '@/utils/tyepconvert'
import { DateFormat } from '@/utils/date/DateUtil'



@Component({
  components: {
    VQuery,
    VTable,
  },
})
export default class ChangeStatusMedicineCabineDialog extends Vue {
  @Prop({ type: Boolean, default: false }) private appendToBody!: boolean

  @Emit('close')
  private close() {
    this.show = false
    this.queryParam = {
      startRow: 1,
      limit: 10,
      orderBy: "create_time desc , id desc",
      recordNo: undefined,
      userId: undefined,
      createTimeDaterange :[],
      finishTimeDaterange :[],
    }
  }
  private data: any = {}
  private show = false

  public async open(data: any) {
    this.show = true
    this.data = data
    if(this.data.recordNo){
      this.queryParam.recordNo = this.data.recordNo
    }
    this.loadData()
  }

   private queryParam = {
    startRow: 1,
    limit: 10,
    orderBy: "create_time desc , id desc",
    recordNo: undefined,
    userId: undefined,
    createTimeDaterange :[],
    finishTimeDaterange :[],
  }
  private tableTotal = 0
  private tableData = []
  private tableCurrntPage = 1

  // 查询条件
  private queryModels: Array<QueryModel> = [
      { title: '用户ID', param: 'userId' },
      { title: '用户名称', param: 'userName' },
      { title: '关联号', param: 'recordNo' },
      { title: '财富类型', param: 'type', type: 'select', selectData: constant.WealthType },
      { title: '途径类型', param: 'wayType', type: 'select', selectData: constant.WealthWayType },
      { title: '状态', param: 'status', type: 'select', selectData: constant.WealthStatus },
      { title: '入帐时间 ', param: 'finishTimeDaterange', type: 'daterange', },
      { title: '创建时间', param: 'createTimeDaterange', type: 'daterange', }
  ]
  // 全局操作
  private queryOperation: Array<TableOperation> = [
    { title: '导出', type: 'primary', click: this.exportOrderHandle},
  ]
  // 数据表头 -
  // 视频比例 ()
  private tableHander: Array<TableHander> = [
    { title: '序号', param: 'id', type: 'index' },
    { title: '用户ID', param: 'userId' },
    { title: '用户名称', param: 'userName' },
    { title: '手机号', param: 'mobilePhone' },
    { title: '财富类型', param: 'type', formatter: WealthTypeFormat},
    { title: '数量', param: 'qty' },
    { title: '应得数量', param: 'shouldQty' },
    { title: '关联号', param: 'recordNo'},
    { title: '途径类型', param: 'wayType', formatter: WealthWayTypeFormat},
    { title: '状态', param: 'status', formatter: WealthStatusFormat},
    { title: '入帐时间', width: 160 , param: 'finishTime', formatter: DateFormat},
    { title: '创建时间', width: 160, param: 'createTime', formatter: DateFormat},
    { title: '备注', param: 'note'},

  ]

  private exportOrderHandle(){

    const loading = this.$loading({
          lock: true,
          text: '正在导出用户积分记录',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
      const param: any = this.getRequestParam()
      param.limit = ""
      param.startRow = ""

      ExportUserWealthRecord(param,this.data.mobilePhone + "-用户积分记录.xlsx").then(res=>{
        loading.close()
      }).catch(()=>{
        loading.close()
      })

  }

  public async loadData() {
    
    const param = this.getRequestParam()
    
    const result = await QueryUserWealthRecordList(param)
    this.tableTotal = result.total
    this.tableData = result.list
  }

  private getRequestParam(){
    const param: any = { ...this.queryParam }
    if(this.data.userId){
      param.userId = this.data.userId
    }
    if (param.createTimeDaterange.length >0) {
      param.createTimes = DateFormat(param.createTimeDaterange[0]) + ',' + DateFormat(param.createTimeDaterange[1])
    }
    if (param.finishTimeDaterange.length >0) {
      param.finishTimes = DateFormat(param.finishTimeDaterange[0]) + ',' + DateFormat(param.finishTimeDaterange[1])
    }
    param.startRow =  (this.tableCurrntPage - 1) * (param.limit || 12)
    return param

  }

  public search() {
    console.log(this.queryParam)
    this.tableCurrntPage = 1
    this.loadData()
  }
  // 分页导航改变
  public pageChange(index: number) {
    this.tableCurrntPage = index
    this.loadData()
  }

  public sizeChange(index: number) {
    this.tableCurrntPage = 1
    this.queryParam.limit = index
    this.loadData()
  }



}
